import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltMediaSourceSettingsToggleIconWireframe from '../VeltMediaSourceSettingsToggleIconWireframe/VeltMediaSourceSettingsToggleIconWireframe';
import VeltMediaSourceSettingsSelectedLabelWireframe from '../VeltMediaSourceSettingsSelectedLabelWireframe/VeltMediaSourceSettingsSelectedLabelWireframe';
import VeltMediaSourceSettingsOptionsWireframe from '../VeltMediaSourceSettingsOptionsWireframe/VeltMediaSourceSettingsOptionsWireframe';
import VeltMediaSourceSettingsDividerWireframe from '../VeltMediaSourceSettingsDividerWireframe/VeltMediaSourceSettingsDividerWireframe';
var VeltMediaSourceSettingsAudioWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-audio-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsAudioWireframe.ToggleIcon = VeltMediaSourceSettingsToggleIconWireframe;
VeltMediaSourceSettingsAudioWireframe.SelectedLabel = VeltMediaSourceSettingsSelectedLabelWireframe;
VeltMediaSourceSettingsAudioWireframe.Options = VeltMediaSourceSettingsOptionsWireframe;
VeltMediaSourceSettingsAudioWireframe.Divider = VeltMediaSourceSettingsDividerWireframe;
export default VeltMediaSourceSettingsAudioWireframe;
